export enum BalanceResponse {
  SUCCESSFUL = 'OK',
  NO_FUNDS = 'NO_FUNDS',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  BLOCK_ACCOUNT = 'BLOCK_ACCOUNT',
  FORCED_BALANCE = 'FORCED_BALANCE'
}
